/* eslint-disable react/no-array-index-key */
import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Box } from "@mui/material";
import useStyles from "./Styles";

interface BillingPortalModalProps {
  open: boolean;
  setOpen: (a: boolean) => void;
  BillingPortal: React.ReactNode;
  BillingInformation: React.ReactNode;
  Summary: React.ReactNode;
  step: number;
  stepBack: () => void;
}

const BillingPortalModal: React.FC<BillingPortalModalProps> = ({
  open,
  setOpen,
  BillingPortal,
  BillingInformation,
  Summary,
  step,
  stepBack,
}) => {
  const closeHandle = () => {
    setOpen(false);
  };

  const { classes } = useStyles();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "900px",
    width: "100%",
    bgcolor: "white",
    boxShadow: 24,
    borderRadius: "12px",
    padding: "20px",
    paddingTop: "30px",
  };

  return (
    <Modal open={open} onClose={closeHandle}>
      <Box sx={style}>
        {step > 2 && (
          <ArrowBackIcon className={classes.arrowBackIcon} onClick={stepBack} />
        )}
        <CloseIcon className={classes.closeIcon} onClick={closeHandle} />
        <Box sx={{ display: "flex", gap: "20px" }}>
          {step === 2 ? BillingPortal : BillingInformation}
          {Summary}
        </Box>
      </Box>
    </Modal>
  );
};

export default BillingPortalModal;
